import React from 'react';
import { Stack, Switch, Text } from '@mantine/core';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import { thumbnailsUnavailableReason } from './carouselThumbnailSources';

export default function CarouselThumbnailsField({ value, onChange }) {
  const { itemProps } = useSelectedItemProps();
  const reason = thumbnailsUnavailableReason(itemProps);
  return (
    <Stack gap={4}>
      <Switch label="Navigation par miniatures" checked={!!value} onChange={(event) => onChange(event.currentTarget.checked)} />
      {value && reason && <Text size="xs" c="dimmed">{reason} Le réglage est conservé.</Text>}
    </Stack>
  );
}
